export const getFluid = (images: any, relativePath: string) => {
	return images.filter((image) => image.node.relativePath === relativePath)[0].node.childImageSharp.fluid;
};

export const getSliderGenerator = (init: {
	numberOfItems: number;
	duration: number;
	multiplier: number;
	height: number;
}) => {
	if (init.numberOfItems <= 0) {
		throw Error("numberOfItems must be greater than 0");
	}

	if (init.multiplier < 2) {
		throw Error("multiplier must be greater or equal than 2");
	}

	if (init.height <= 0) {
		throw Error("height must be greater than 0");
	}

	if (init.duration <= 0) {
		throw Error("duration must be greater than 0");
	}

	return (count: number): { count: number; top: number; action: "transform" | "reset" | "none" } => {
		if (count % init.multiplier === 0) {
			const top = (((count / init.multiplier) % init.numberOfItems) + 1) * init.height;
			return { count: count + 1, top, action: "transform" };
		} else if ((count - 1 + init.multiplier) % (init.multiplier * init.numberOfItems) === 0) {
			return { count: count + 1, top: 0, action: "reset" };
		}

		return { count: count + 1, top: -1, action: "none" };
	};
};

// !IMPORTANT DO NOT USE .md FILES FOR THE BLOG ON THE NEW WEBSITE, USE .mdx OR SOMETHING SIMILAR INSTEAD

// DEVNOTE This is needed beause of the way Mailchimp handles it's scripts...
export const loadMailChimpScript = () => {
	const form = document.querySelector("#mc_embed_signup");
	if (!form) return;

	if (!document.querySelector('script[src*="mc-validate.js"]') && form && form.parentNode) {
		const script = document.createElement("script");
		script.src = "//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js";
		script.async = true;
		form.parentNode.insertBefore(script, form);
	}
};

export const setupGitOpsPDFDownload = () => {
	const button = document.querySelector("#mc-embedded-subscribe");
	if (!button) return;

	const handleClick = () => {
		// eslint-disable-next-line no-restricted-globals
		setTimeout(() => {
			const visibleErrors = Array.from(document.querySelectorAll("div.mce_inline_error")).filter(
				(el) => getComputedStyle(el).display === "block"
			);

			if (visibleErrors.length === 0) {
				const link = document.createElement("a");
				link.href = "/pdf/Gitops_A_Practical_Implementation.pdf";
				link.download = "Gitops_A_Practical_Implementation.pdf";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}, 2000);
	};

	button.addEventListener("click", handleClick);

	return () => {
		button.removeEventListener("click", handleClick);
	};
};
